import React, { useContext, useState } from 'react';
import { Trans } from '@ui/i18n/trans';
import { Dialog } from '@ui/overlays/dialog/dialog';
import { DialogHeader } from '@ui/overlays/dialog/dialog-header';
import { DialogBody } from '@ui/overlays/dialog/dialog-body';
import { TextField } from '@ui/forms/input-field/text-field/text-field';
import { SearchIcon } from '@ui/icons/material/Search';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { removeCompanyMemberApi, searchFreeMembersApi } from './api';
import { useAuth } from '@common/auth/use-auth';
import { DialogFooter } from '@ui/overlays/dialog/dialog-footer';
import { DialogContext } from '@ui/overlays/dialog/dialog-context';
import { toast } from '@ui/toast/toast';
import { message } from '@ui/i18n/message';

export function DeleteMemberDialog({userId}: {userId: number}) {
  const {close} = useContext(DialogContext);
  const queryClient = useQueryClient()
  const {mutate} = useMutation({
    mutationKey: ['removeCompanyMember'],
    mutationFn: ()=>{return removeCompanyMemberApi({userId})},
    onSuccess: ()=>{
      toast(message('Member deleted successfuly!'));
      queryClient.invalidateQueries({ queryKey: ['companyMembers'] })
    }
  })

  return (
    <Dialog>
      <DialogHeader>
        <Trans message="Add Member" />
      </DialogHeader>
      <DialogBody>
        <h3><Trans message='Are you sure you want to delete this member ?'/></h3>
      </DialogBody>
      <DialogFooter>
        <button onClick={()=>{close()}}>Cancel</button>
        <button onClick={()=>{close(); mutate();}} className='bg-primary text-white px-16 py-5 rounded-md'><Trans message='Delete'/></button>
      </DialogFooter>
    </Dialog>
  );
}